import React, { useContext, useEffect, useState } from 'react';
import './CartItems.css';
import { ShopContext } from '../../Context/ShopContext';
import { Link } from 'react-router-dom';
import delete_icon from '../Assets/delete.png';

const CartItems = () => {
  const { cartItems, setSelectedItems, selectedItems, removeSelectedItemsFromCart, updateItemQuantity } = useContext(ShopContext);
  const [products, setProducts] = useState({});
  const databaseUrl = process.env.REACT_APP_DATABASE_URL;

  useEffect(() => {
    const fetchProducts = async () => {
      const fetchedProducts = {};
      for (const item of cartItems) {
        try {
          const response = await fetch(`${databaseUrl}/product/${item.product_id}`);
          const data = await response.json();
          if (data.success) {
            fetchedProducts[item.product_id] = data.product;
          } else {
            console.error(`Failed to fetch product ${item.product_id}:`, data.message);
          }
        } catch (error) {
          console.error(`Error fetching product ${item.product_id}:`, error);
        }
      }
      setProducts(fetchedProducts);
    };

    if (cartItems.length > 0) {
      fetchProducts();
    }
  }, [cartItems, databaseUrl]);

  const [selectedProducts, setSelectedProducts] = useState({});
  const [subtotal, setSubtotal] = useState(0);
  const [num_purchase_products, setNumPurchaseProducts] = useState(0);

  useEffect(() => {
    const fetchProducts = async () => {
      const fetchedProducts = {};
      for (const item of selectedItems) {
        try {
          const response = await fetch(`${databaseUrl}/product/${item.product_id}`);
          const data = await response.json();
          if (data.success) {
            fetchedProducts[item.product_id] = data.product;
          } else {
            console.error(`Failed to fetch product ${item.product_id}:`, data.message);
          }
        } catch (error) {
          console.error(`Error fetching product ${item.product_id}:`, error);
        }
      }
      setSelectedProducts(fetchedProducts);
    };

    if (selectedItems.length > 0) {
      fetchProducts();
    }
  }, [selectedItems]);

  useEffect(() => {
    if (Object.keys(selectedProducts).length > 0) {
      const productArray = Object.values(selectedProducts);
      let total = 0;
      let num_purchase_products = 0;

      selectedItems.forEach(item => {
        const quantity = item.quantity || 0;
        const itemInfo = productArray.find(product => product.id === item.product_id);
        if (itemInfo) {
          total += itemInfo.new_price * item.quantity;
        }
        num_purchase_products += quantity;
      });
      setSubtotal(total);
      setNumPurchaseProducts(num_purchase_products);
    }
  }, [selectedProducts, cartItems]);

  useEffect(() => {
    setSelectedItems([]);
  }, [setSelectedItems]);

  const toggleSelectItem = (productId) => {
    setSelectedItems((prevSelected) => {
      if (prevSelected.some(item => item.product_id === productId)) {
        return prevSelected.filter(item => item.product_id !== productId);
      } else {
        const productToSelect = cartItems.find(item => item.product_id === productId);
        return [...prevSelected, productToSelect];
      }
    });
  };

  const toggleSelectAll = () => {
    setSelectedItems((prevSelected) => {
      if (prevSelected.length === cartItems.length) {
        return [];
      } else {
        return cartItems;
      }
    });
  };

  const removeSelectedItems = () => {
    removeSelectedItemsFromCart();
  };

  return (
    <div className='px-4 lg:px-[10%] pt-24 md:pt-44 bg-[#E6B17E33] flex flex-col md:flex-row min-h-screen gap-8 md:gap-16'>
      <div className='flex flex-col w-full md:w-3/5'>
        <div className='flex justify-between shadow-lg bg-white p-4 rounded-lg'>
          <div className='flex gap-2'>
            <button 
              className={`h-5 w-5 rounded-full border border-[#9C9C9C] ${selectedItems.length === cartItems.length ? 'bg-[#551e19]' : 'bg-white'}`}
              onClick= {() => toggleSelectAll()}
            >
            </button>
            {selectedItems.length === cartItems.length ? <p>UNSELECT ALL</p> : <p>SELECT ALL</p>}
          </div>
          <div className='flex gap-2'>
            <button 
              className={`flex gap-2 ${selectedItems.length === 0 ? 'pointer-events-none opacity-70' : ''}`}
              onClick= {removeSelectedItems}
            >
              <img className='h-6 w-6' src={delete_icon} alt='delete' />
              <p>DELETE</p>
            </button>
          </div>
        </div>
        <div className="flex flex-col w-full space-y-4 bg-white rounded-lg my-10">
          <div className="grid grid-cols-[0.5fr_2fr_1fr_1fr] gap-4 p-4 items-center text-sm md:text-base">
            <p className="font-semibold text-center text-gray-700">SELECT</p>
            <p className="font-semibold text-center text-gray-700">PRODUCT</p>
            <p className="font-semibold text-center text-gray-700">PRICE</p>
            <p className="font-semibold text-center text-gray-700">QUANTITY</p>
          </div>
          {cartItems.map(item => {
            const product = products[item.product_id];
            if (product) {
              return (
                <React.Fragment key={item.product_id}>
                  <hr />
                  <div className="grid grid-cols-[0.5fr_2fr_1fr_1fr] gap-4 p-4 items-center">
                    <button
                      className={`h-5 w-5 rounded-full border border-gray-300 ${
                        selectedItems.some(
                          selectedItem => selectedItem.product_id === item.product_id
                        )
                          ? 'bg-[#551e19]'
                          : 'bg-white'
                      }`}
                      onClick={() => toggleSelectItem(item.product_id)}
                    ></button>

                    <div className="flex flex-col sm:flex-row items-center justify-start space-x-4">
                      <img
                        src={product.image[0]}
                        alt="Product"
                        className="w-16 h-16 rounded-lg object-cover"
                      />
                      <div>
                        <p className="text-gray-700 font-medium text-xs md:text-sm">{product.name}</p>
                      </div>
                    </div>

                    <p className="text-center text-gray-500">Rs.{product.new_price}</p>

                    <div className="flex items-center justify-center rounded-lg">
                      <button
                        className="flex items-center justify-center bg-gray-200 text-gray-600 rounded-l-lg px-1 md:px-2 lg:px-3 md:py-1 hover:bg-gray-300 border-2 border-r-0 border-gray-300"
                        onClick={() =>
                          item.quantity > 1 &&
                          updateItemQuantity(item.product_id, item.quantity - 1)
                        }
                      >
                        -
                      </button>
                      <span className="w-6 md:w-8 lg:w-10 text-center px-1 md:px-3 md:py-1 border-y-2 border-gray-300">
                        {item.quantity}
                      </span>
                      <button
                        className="flex items-center justify-center bg-gray-200 text-gray-600 rounded-r-lg px-1 md:px-2 lg:px-3 md:py-1 hover:bg-gray-300 border-2 border-l-0 border-gray-300"
                        onClick={() =>
                          updateItemQuantity(item.product_id, item.quantity + 1)
                        }
                      >
                        +
                      </button>
                    </div>
                  </div>
                </React.Fragment>
              );
            }
            return null;
          })}
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-sm p-6 w-full md:w-2/5 flex flex-col h-max mb-10">
        <h3 className="text-lg font-semibold text-gray-700 mb-4">Order Summary</h3>
        <div className="text-sm text-gray-600 space-y-2">
          <p>
            <span>Subtotal: </span>
            {selectedItems.length > 0 ? <span className="float-right font-medium">Rs.{subtotal}</span> : <span className="float-right font-medium">Rs.0</span>}
          </p>
          <p>
            <span>Number of Products: </span>
            {selectedItems.length > 0 ? <span className="float-right font-medium">{num_purchase_products}</span> : <span className="float-right font-medium">0</span>}
          </p>
        </div>
        <h4 className="text-lg font-semibold text-gray-800 mt-4">
          <span>Total: </span>
          {selectedItems.length > 0 ? <span className="float-right text-orange-600">Rs.{subtotal}</span> : <span className="float-right text-orange-600">Rs.0</span>}
        </h4>
        <Link style={{ textDecoration: 'none' }} to='/order/customer_details'>
          <button className="mt-6 w-full py-2 bg-orange-500 text-white font-medium rounded-md hover:bg-orange-600 disabled:hover:bg-orange-500 disabled:hover:bg-opacity-60 disabled:bg-opacity-60" disabled={selectedItems.length === 0}>
            Proceed to Checkout
          </button>
        </Link>
      </div>
    </div>
  );
}

export default CartItems;